module.exports = __webpack_public_path__ + "img/uniswap.88cf3d08.svg";